import Cookies from 'js-cookie'
import verge from 'verge'

import {pollAndThen} from '../utils'

/**
 * Holds the previous page's pathname
 * @type {String|null}
 */
let prevPath

/**
 * Fire the Segment `page` function to denote a page change. We must use the local
 * `prevPath` variable to keep track of "referrer" for in-app navigations since
 * the browser's `document.referrer` will not update.
 *
 * @param {String} path The pathname of the current page's URL
 */
export const trackPage = (path) => {
  const userId = window.userObject && window.userObject.userId
  const attributes = {
    viewportWidth: verge.viewportW(),
    viewportHeight: verge.viewportH(),
    deviceWidth: window.screen ? window.screen.width : 0,
    deviceHeight: window.screen ? window.screen.height : 0,
    name: path,
    referrer: prevPath || document.referrer,
  }
  const integrations = {
    Iterable: !!userId,
  }
  if (userId) {
    attributes.userId = userId
  }
  analytics.page(attributes, integrations)
  prevPath = window.location.href
}

/**
 * Set cookies that the server can read from HTTP requests and use in its own
 * analytics reporting.
 *
 * @returns {void}
 */
const setAnalyticsCookies = () => {
  const amplitudeSessionId = window.amplitude.getSessionId()
  const segmentAnonymousId = window.analytics.user().anonymousId()
  Cookies.set('amplitude_session_id', amplitudeSessionId)
  Cookies.set('segment_anonymous_id', segmentAnonymousId)
  if (window.screen.width) {
    Cookies.set('tbt_screen_width', window.screen.width)
  }
  if (window.screen.height) {
    Cookies.set('tbt_screen_height', window.screen.height)
  }
}

/**
 * Tests whether Segment and Amplitude have loaded and executed
 *
 * @returns {Boolean}
 */
const segmentAndAmplitudeLoaded = () =>
  window.analytics && window.amplitude && window.amplitude.getSessionId

/**
 * Analytics logic to run on application bootstrap
 *
 * @returns {void}
 */
export const documentReady = () => {
  pollAndThen(segmentAndAmplitudeLoaded, setAnalyticsCookies)
}
